import { BaseRouteService } from 'core/services';

class RestockDateRouteService extends BaseRouteService {
	constructor() {
		super();
		this.base = 'product-inventory-restock-date/';
	}
	createRestockDate(restockDateParams, sourceOfChange) {
		return super.update(this.base + 'create/?sourceOfChange={sourceOfChange}', restockDateParams, {
			sourceOfChange,
		});
	}

	updateRestockDate(restockDateParams, sourceOfChange) {
		return super.update(this.base + 'update/?sourceOfChange={sourceOfChange}', restockDateParams, {
			sourceOfChange,
		});
	}
}
export default RestockDateRouteService;
